import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

export { ComponentWithCondition } from './component-with-condition';

export const fg: typeof FeatureGates.checkGate = (gateName) => {
	if (!FeatureGates.initializeCompleted() && process.env.NODE_ENV !== 'production') {
		// eslint-disable-next-line no-console
		console.log('Feature gate client has not been initialized. Gate: ', gateName);
	}

	return FeatureGates.checkGate(gateName);
};

export const expVal: typeof FeatureGates.getExperimentValue = <T,>(
	experimentName: string,
	param: string,
	defaultValue: T,
): T => {
	if (!FeatureGates.initializeCompleted() && process.env.NODE_ENV !== 'production') {
		// eslint-disable-next-line no-console
		console.log('Feature gate client has not been initialized. Experiment: ', experimentName);
	}
	return FeatureGates.getExperimentValue(experimentName, param, defaultValue);
};
